export { default } from "./NGNRSFooter";